import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Cache } from './cache.service';
import {
  GetArtifactResponse,
  GetArtifactsResponse,
  GetAssetInstancesByCompanyRequest,
  GetAssetResourcesByCompanyRequest,
  GetBuildersResponse,
  SituWarpApiClient,
  GetProductReplacementThemeRequest,
  GetProductReplacementThemeResponse,
  SaveProductReplacementThemeRequest,
  SaveProductReplacementThemeResponse
} from 'situ-warpapi-client';

@Injectable({
  providedIn: 'root'
})
export class WarpApiService {
  cacheKey: Guid = Guid.create();
  oldCacheKey: Guid = Guid.create();

  constructor(
    private situWarpApiClient: SituWarpApiClient
  ) {
    this.oldCacheKey = this.cacheKey;
  }

  @Cache({
    duration: 1800000
  })
  GetBuilders(): Promise<GetBuildersResponse> {
    return this.situWarpApiClient.getBuilders();
  }

  @Cache({
    duration: 1800000
  })
  GetAssetTemplates(): Promise<GetArtifactsResponse> {
    return this.situWarpApiClient.getAssetTemplates();
  }

  GetArtifactLatestVersion(callerReferenceKey: string): Promise<GetArtifactResponse> {
    return this.situWarpApiClient.getArtifactLatestVersion(callerReferenceKey);
  }

  GetTheme(request: GetProductReplacementThemeRequest): Promise<GetProductReplacementThemeResponse> {
    return this.situWarpApiClient.getProductReplacementTheme(request);
  }
  
  SaveTheme(request: SaveProductReplacementThemeRequest): Promise<SaveProductReplacementThemeResponse> {
    return this.situWarpApiClient.saveProductReplacementTheme(request);
  }

  GetAssetInstancesByCompany(request: GetAssetInstancesByCompanyRequest, refreshData: boolean = false): Promise<GetArtifactsResponse> {
    if (refreshData) {
      this.RefreshData();
      return this.getAssetInstancesByCompany(request, this.cacheKey, this.oldCacheKey);
    } else {
      return this.getAssetInstancesByCompany(request, this.cacheKey, this.oldCacheKey);
    }
  }
  
  GetAssetResourcesByCompany(request: GetAssetResourcesByCompanyRequest, refreshData: boolean = false): Promise<GetArtifactsResponse> {
    if (refreshData) {
      this.RefreshData();
      return this.getAssetResourcesByCompany(request, this.cacheKey, this.oldCacheKey);
    } else {
      return this.getAssetResourcesByCompany(request, this.cacheKey, this.oldCacheKey);
    }
  }
  
  RefreshData() {
    this.oldCacheKey = this.cacheKey;
    this.cacheKey = Guid.create();
  }

  @Cache({
    duration: 900000
  })
  private getAssetInstancesByCompany(request: GetAssetInstancesByCompanyRequest, cacheKey: Guid, oldCacheKey: Guid): Promise<GetArtifactsResponse> {
    return this.situWarpApiClient.getAssetInstancesByCompany(request);
  }
  
  @Cache({
    duration: 900000
  })
  private getAssetResourcesByCompany(request: GetAssetResourcesByCompanyRequest, cacheKey: Guid, oldCacheKey: Guid): Promise<GetArtifactsResponse> {
    return this.situWarpApiClient.getAssetResourcesByCompany(request);
  }
}